import { Divider, Link } from '@bufferapp/components';
import { Button, Switch, Text } from '@bufferapp/ui';
import { blue, gray } from '@bufferapp/ui/style/colors';
import React from 'react';
import styled from 'styled-components';
import {
  selectGeneralSettingsProfileId,
  selectRemindersAreEnabled,
} from '~/general-settings/selectors';
import {
  selectIsManagerInChannel,
  selectNotificationsEnabled,
} from '~/profile-sidebar/selectors';
import { useAppDispatch, useAppSelector } from '~/store';
import { actions } from '../../reducer';

export const SettingsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SwitchWrapper = styled.div`
  display: flex;
  width: 130px;
  justify-content: space-between;
`;

export const SwitchLabel = styled.span<{ disabled?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  flex-grow: 1;
  color: ${({ disabled }) => (disabled ? gray : 'inherit')};
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TextContent = styled.div`
  max-width: 577px;
`;

const TextLink = styled.span`
  color: ${blue};
`;

export const InstagramReminders = () => {
  const dispatch = useAppDispatch();
  const notificationsEnabled = useAppSelector(selectNotificationsEnabled);
  const profileId = useAppSelector(selectGeneralSettingsProfileId);
  const isManager = useAppSelector(selectIsManagerInChannel(profileId));
  const remindersAreEnabled = useAppSelector(selectRemindersAreEnabled);

  const onToggle = () => {
    dispatch(
      actions.handleRemindersToggle({
        profileId,
        allowReminders: !remindersAreEnabled,
      })
    );
  };

  return (
    <SettingsWrapper>
      <Header>
        <Text type="h3">Instagram Reminders by Default</Text>

        <SwitchWrapper>
          <SwitchLabel disabled={isManager === false || !notificationsEnabled}>
            Reminders {remindersAreEnabled ? 'on' : 'off'}
          </SwitchLabel>
          <Switch
            id="instagram-reminders-switch"
            data-testid="instagram-reminders-switch"
            disabled={isManager === false || !notificationsEnabled}
            isOn={remindersAreEnabled}
            size="small"
            handleSwitch={onToggle}
          />
        </SwitchWrapper>
      </Header>
      <Body>
        <TextContent>
          <Text type="p">
            Share all instagram posts, reels and stories as Reminders by
            default. This means Buffer won&apos;t post directly to Instagram for
            you. You can still toggle reminders for individual posts while
            creating them!{' '}
            <Link
              href="https://support.buffer.com/hc/en-us/articles/360037766294-How-Instagram-works-with-Buffer-Publish"
              newTab
              unstyled
            >
              <TextLink>More about Reminders</TextLink>
            </Link>
          </Text>
        </TextContent>
        <Button onClick={() => null} type="primary" label="Set Up Reminders" />
      </Body>
      <Divider />
    </SettingsWrapper>
  );
};
